import { 
  LayoutDashboard, 
  FileText, 
  Plus, 
  Activity, 
  X,
  TrendingUp,
  Users,
  Settings,
  BarChart3,
  Package,
  Receipt,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  Shield,
  Award,
  Briefcase,
  Search,
  ShoppingCart,
  ClipboardList,
  ScrollText,
  FileSignature,
  Send,
  Building,
  PieChart,
  Brain,
  Network,
  ShieldCheck,
  Globe,
  GitPullRequest,
  Sparkles,
  Calculator,
  CreditCard,
  Banknote
} from 'lucide-react'

export const clientNavigation = [
  {
    name: 'Dashboard',
    headerTitle: 'Executive Dashboard',
    href: '/dashboard',
    icon: LayoutDashboard,
    description: 'Real-time enterprise intelligence and decision support system.',
    hideDescriptionInSidebar: true,
    category: 'main',
    module: 'dashboard'
  },
  {
    name: 'Plan (Budget)',
    href: '/budget',
    icon: BarChart3,
    description: 'Financial Planning & Control',
    category: 'main',
    module: 'budget',
    children: [
      {
        name: 'Budget Management',
        href: '#',
        icon: PieChart,
        description: 'Allocations & Planning',
        children: [
          { name: 'Overview', href: '/budget/overview', icon: LayoutDashboard, description: 'Budget Status' },
          { name: 'Planning', href: '/budget/planning', icon: ClipboardList, description: 'Allocations' }
        ]
      },
      {
        name: 'Budget Control',
        href: '#',
        icon: ShieldCheck,
        description: 'Rules & Compliance',
        children: [
          { name: 'Control Dashboard', href: '/budget-control/dashboard', icon: LayoutDashboard, description: 'Control Stats' },
          { name: 'Rules Engine', href: '/budget-control/rules', icon: Settings, description: 'Control Rules' },
          { name: 'Overrides', href: '/budget-control/overrides', icon: Activity, description: 'Exception Handling' },
          { name: 'Commitments', href: '/budget-control/commitments', icon: FileText, description: 'Commitment Register' }
        ]
      }
    ]
  },
  {
    name: 'Procure-To-Order',
    href: '/buy',
    icon: ShoppingCart,
    description: 'Requisitions & Approvals',
    category: 'main',
    module: 'procurement',
    children: [
       { name: 'Requisition', href: '/requisitions', icon: ClipboardList, description: 'Request items', permissions: ['Requisition:read'] },
       { name: 'Sourcing (RFx)', href: '/rfx', icon: Send, description: 'RFQs and RFPs' },
       { 
         name: 'Order Receipts (OR)', 
         href: '/order-receipts', 
         icon: ClipboardList, 
         description: 'Record and track order receipts',
         showDescriptionBelow: true
       }
    ]
  },
  {
    name: 'Approval Center',
    href: '/approvals',
    icon: GitPullRequest,
    description: 'Central hub for approvals across modules',
    category: 'main',
    module: 'approvals',
    permissions: ['Requisition:approve', 'PurchaseOrder:approve'],
    children: [
      {
        name: 'Approvals',
        href: '#',
        icon: GitPullRequest,
        description: 'Workflow Management',
        children: [
          { 
            name: 'Overview', 
            href: '/approvals', 
            icon: LayoutDashboard, 
            description: 'Centralized hub for approvals across requisitions, sourcing, orders, and invoicing.',
            showDescriptionBelow: true,
            fullWidth: true
          },
          { 
            name: 'My Inbox', 
            href: '/approvals/inbox', 
            icon: GitPullRequest, 
            description: 'Review and action pending requests',
            showDescriptionBelow: true,
            fullWidth: true
          },
          { 
            name: 'Workflow Config', 
            href: '/approvals/workflows', 
            icon: Settings, 
            description: 'Manage approval chains and workflow definitions', 
            permissions: ['Settings:update'],
            showDescriptionBelow: true,
            fullWidth: true
          }
        ]
      }
    ]
  },
  {
    name: 'Source (Upstream)',
    href: '/source',
    icon: Globe,
    description: 'Sourcing & Contracts',
    category: 'main',
    module: 'sourcing',
    children: [
      {
        name: 'Upstream Operations',
        href: '#',
        icon: Globe,
        description: 'Sourcing Activities',
        children: [
          { name: 'Quotation', href: '/quotations', icon: ScrollText, description: 'Manage quotes' },
          { name: 'Client Purchase Orders', href: '/purchase-orders', icon: FileText, description: 'Sales POs', permissions: ['PurchaseOrder:read'] },
          { name: 'Invoicing', href: '/finance/accounting/invoices', icon: Receipt, description: 'Process payments', permissions: ['Invoice:read'] }
        ]
      }
    ]
  },
  {
    name: 'Finance',
    href: '/finance',
    icon: Banknote,
    description: 'Financial Management',
    category: 'main',
    module: 'finance',
    children: [
      {
        name: 'Accounting',
        href: '#',
        icon: Calculator,
        description: 'AP & AR',
        children: [
          { 
            name: 'General Ledger', 
            href: '/finance/accounting/general-ledger', 
            icon: FileText, 
            description: 'Centralized financial accounting and reporting.',
            showDescriptionBelow: true,
            fullWidth: true
          },
          { name: 'Accounts Payable', href: '/finance/accounting/accounts-payable', icon: CreditCard, description: 'Manage vendor invoices, payments, and 3-way matching.', showDescriptionBelow: true, fullWidth: true },
          { name: 'Accounts Receivable', href: '/finance/accounting/accounts-receivable', icon: Banknote, description: 'Manage client invoices, collections, and revenue analytics.', showDescriptionBelow: true, fullWidth: true },
          { 
            name: 'Cash & Bank', 
            href: '/finance/accounting/cash-bank', 
            icon: Building, 
            description: 'Manage bank accounts and cash flow.',
            showDescriptionBelow: true,
            fullWidth: true
          },
          { 
            name: 'Tax Accounting', 
            href: '/finance/accounting/tax', 
            icon: Calculator, 
            description: 'Manage tax liabilities and filings.',
            showDescriptionBelow: true,
            fullWidth: true
          },
          { name: 'Invoices', href: '/finance/accounting/invoices', icon: Receipt, description: 'Manage Invoices', permissions: ['Invoice:read'] },
          { name: 'Payments', href: '/finance/accounting/payments', icon: CreditCard, description: 'Manage Payments', permissions: ['Payment:read'] }
        ]
      }
    ]
  },
  {
    name: 'Govern & Optimize',
    href: '/govern',
    icon: Shield,
    description: 'GRC & Intelligence',
    category: 'main',
    module: 'grc',
    children: [
      {
        name: 'Insights & Compliance',
        href: '#',
        icon: ShieldCheck,
        description: 'Analytics & Risk',
        children: [
          { 
            name: 'Financial Intelligence', 
            href: '/analytics', 
            icon: Brain, 
            description: 'AI-driven spend analysis, forecasting, and risk intelligence',
            showDescriptionBelow: true,
            fullWidth: true
          },
          { 
            name: 'GRC', 
            href: '/grc', 
            icon: ShieldCheck, 
            description: 'Centralized monitoring and audit controls',
            showDescriptionBelow: true
          }
        ]
      }
    ]
  },
  {
    name: 'Platform & Foundation',
    href: '/platform',
    icon: Settings,
    description: 'Admin & Config',
    category: 'main',
    module: 'platform',
    permissions: ['Settings:read', 'User:read'],
    children: [
      {
        name: 'Entity Management',
        href: '#',
        icon: Users,
        description: 'Manage Stakeholders',
        permissions: ['User:read', 'Vendor:read'],
        direction: 'left',
        children: [
            { name: 'Client Management', href: '/settings/clients', icon: Building, description: 'Manage clients' },
            { name: 'Vendor Management', href: '/settings/vendors', icon: Building, description: 'Manage vendors', permissions: ['Vendor:read'] }
        ]
      },
      {
        name: 'Operations & Contracts',
        href: '#',
        icon: Briefcase,
        description: 'Business Rules',
        direction: 'left',
        children: [
            { name: 'Vendor Purchase Orders', href: '/vendor-pos', icon: ShoppingCart, description: 'Procurement POs', permissions: ['PurchaseOrder:read'] },
            { name: 'Inventory', href: '/settings/inventory', icon: Package, description: 'Track stock' },
            { name: 'Contract Management', href: '/settings/contracts', icon: FileSignature, description: 'Manage agreements' }
        ]
      },
      {
        name: 'System Configuration',
        href: '#',
        icon: Settings,
        description: 'Global Settings',
        permissions: ['Settings:read'],
        direction: 'left',
        children: [
            { name: 'System Settings', href: '/settings/system', icon: Settings, description: 'Configuration', permissions: ['Settings:read'] },
            { name: 'Billing & Usage', href: '/settings/billing', icon: Activity, description: 'License & Sessions', permissions: ['Settings:read'], fullWidth: true },
            { name: 'License Management', href: '/settings/license', icon: Shield, description: 'Activate and review licenses', permissions: ['Settings:read'] },
            { name: 'Subscription Management', href: '/settings/subscription', icon: CreditCard, description: 'Choose marketplace subscription plans', permissions: ['Settings:read'], fullWidth: true },
            { name: 'Admin Control Tower', href: '/settings/control-tower', icon: BarChart3, description: 'Admin dashboard', permissions: ['Settings:read'], fullWidth: true }
        ]
      }
    ]
  }
]

export const vendorNavigation = [
  {
    name: 'Dashboard',
    headerTitle: 'Vendor Portal',
    href: '/vendor/dashboard',
    icon: LayoutDashboard,
    description: 'Overview of your orders, bids, and payments.',
    hideDescriptionInSidebar: true,
    category: 'main',
    module: 'dashboard'
  },
  {
    name: 'Bid & Sourcing',
    href: '/vendor/sourcing',
    icon: Globe,
    description: 'Participate in RFx',
    category: 'main',
    module: 'sourcing',
    children: [
      {
        name: 'RFx Management',
        href: '#',
        icon: Globe,
        description: 'Bidding Activities',
        children: [
          { name: 'My Bids', href: '/vendor/bids', icon: Send, description: 'Manage your bids' },
          { name: 'Open RFx', href: '/vendor/rfx', icon: Search, description: 'Find opportunities' },
          { name: 'AI RFx Matching', href: '/vendor/rfx-matching', icon: Sparkles, description: 'Smart Recommendations' }
        ]
      }
    ]
  },
  {
    name: 'Orders & Deliveries',
    href: '/vendor/orders',
    icon: ShoppingCart,
    description: 'Manage Orders',
    category: 'main',
    module: 'procurement',
    children: [
      {
        name: 'Fulfillment',
        href: '#',
        icon: Package,
        description: 'Order Processing',
        children: [
          { name: 'Purchase Orders', href: '/vendor-pos', icon: FileText, description: 'Received POs' },
          { name: 'Shipments', href: '/vendor/shipments', icon: Package, description: 'Dispatch status' }
        ]
      }
    ]
  },
  {
    name: 'Finance',
    href: '/vendor/finance',
    icon: Receipt,
    description: 'Invoices & Payments',
    category: 'main',
    module: 'finance',
    children: [
      {
        name: 'Accounting',
        href: '#',
        icon: Receipt,
        description: 'Financial Records',
        children: [
          { name: 'Invoices', href: '/vendor/finance/invoices', icon: FileText, description: 'Submit & Track' },
          { name: 'Payments', href: '/vendor/finance/payments', icon: Receipt, description: 'Payment Status' }
        ]
      }
    ]
  },
  {
    name: 'Profile & Support',
    href: '/vendor/account',
    icon: Users,
    description: 'Account Settings',
    category: 'main',
    module: 'settings',
    children: [
      {
        name: 'Settings',
        href: '#',
        icon: Settings,
        description: 'Manage Account',
        children: [
          { name: 'Company Profile', href: '/vendor/profile', icon: Building, description: 'Update details' },
          { name: 'Support', href: '/vendor/support', icon: Activity, description: 'Get Help' }
        ]
      }
    ]
  }
]

export const navigation = clientNavigation;
